// src/features/projectsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const ProjectHistory = createSlice({
  name: 'ProjectHistory',
  initialState: {
    singleProject: [],
    singleStatus: 'idle',
    singleError: null
  },
  reducers: {
    setProjectHistory: (state, action) => {
      console.log('Setting Single project History in slice:', action.payload);
      state.singleProject = action.payload;
      state.singleStatus = 'succeeded';
      state.singleError = null;
    },
    setErrorHistory: (state, action) => {
      state.singleError = action.payload;
      state.singleStatus = 'failed';
    },
    clearProjectHistory: (state) => {
      state.singleProject = [];
      state.singleStatus = 'idle';
      state.singleError = null;
    }
  }
});

export const { setProjectHistory, setErrorHistory, clearProjectHistory } = ProjectHistory.actions;


export default ProjectHistory.reducer;